import {Alert, Button} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getVisitConstructorErrorOrNull } from "../../../constants/SubscriptionConstants";
import { fetchConstructor } from "../../../slices/ProjectDetailSlice";
import { RootState } from "../../../slices/Store";

// updated
export default function ProjectDetailViewConstructor() {
    const dispatch = useDispatch();
    const projectDetailState = useSelector(
        (state: RootState) => state.projectDetail
    );

    const fetchConstructorData = () => {
        fetchConstructor(projectDetailState, dispatch);
    };

    // if constructor view info is available, hide the button
    if (projectDetailState.projectDetail?.constructorViewInfo) {
        return <></>;
    }

    // we display the view constructor button when the project hasn't been visited and is available for visit
    let errorMessage = getVisitConstructorErrorOrNull(
        projectDetailState.projectDetail
    );

    const buttonTitle = "مشاهده اطلاعات سازنده";

    return (
        <>
        <Button
            fullWidth
            color="secondary"
            variant="contained"
            onClick={fetchConstructorData}
            sx={{ mb: 2 }}
            disabled={
                projectDetailState.errorMessage !== null || projectDetailState.fetchingConstructor || errorMessage !== null
            }
        >
            {buttonTitle}
        </Button>
            {
                (projectDetailState.errorMessage !== null || errorMessage) &&
                <Alert severity='error' sx={{marginBottom: 2}}>{projectDetailState.errorMessage || errorMessage}</Alert>
            }
        </>
    );
}
